import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  Skeleton,
  Alert
} from "@mui/material";
import instId from "./network/instituteId";
import Network from "./network/Network";
import CustomCarousel from "./CustomCarosoul";

export const SecondSection = ({ endpointsUrl }) => {

  const isMobile = useMediaQuery("(max-width:768px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getBanners();
  }, []);

  const getBanners = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await Network.fetchBannerss(instId);
      const fetchedBanners = response.banners || [];
      let resultBanner = [];
      fetchedBanners.forEach((item) => {
        if (item?.group === 'Top Banner') {
          // item.contentLink = "https://classio.in-maa-1.linodeobjects.com/ExamOrientedTestSyllabusGroup2.pdf";
          resultBanner.push(item);
        }
      });

      if (resultBanner.length > 0) {
        const extendedBanners = [...resultBanner, resultBanner[0]];
        setBanners(extendedBanners);
      } else {
        setBanners([]);
      }
    } catch (error) {
      console.error('Failed to fetch banners:', error);
      setError('Failed to load banners. Please try again later.');
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        pt: { xs: 8, md: 5 }, // Reduced top padding
        pb: { xs: 2, md: 3 }, // Reduced bottom padding
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 80%, rgba(19, 84, 193, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(13, 71, 161, 0.1) 0%, transparent 50%)',
          pointerEvents: 'none',
        }
      }}
    >

      {/* Full Width Carousel Container */}
      <Container
        maxWidth="xl"
        sx={{
          position: 'relative',
          zIndex: 1,
          px: { xs: 2, sm: 3, md: 0 }, // Increased padding for desktop arrows
          overflow: 'visible', // Allow arrows to show outside
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            overflow: 'visible', // Allow arrows to show outside
            borderRadius: { xs: 2, md: 3 },
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
            background: '#fff',
          }}
        >
          {loading ? (
            <Skeleton
              variant="rectangular"
              width="100%"
              height={{ xs: 200, sm: 280, md: 380, lg: 450 }}
              sx={{
                borderRadius: { xs: 2, md: 3 },
                animation: 'pulse 1.5s ease-in-out infinite alternate'
              }}
            />
          ) : error ? (
            <Box sx={{ p: 2 }}>
              <Alert
                severity="error"
                sx={{
                  borderRadius: 2,
                  '& .MuiAlert-message': {
                    fontSize: '1.1rem'
                  }
                }}
              >
                {error}
              </Alert>
            </Box>
          ) : banners?.length > 0 ? (
            <CustomCarousel
              banners={banners}
              setBanners={setBanners}
              endpointsUrl={endpointsUrl}
            />
          ) : (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: { xs: 200, sm: 280, md: 380 },
                background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: 'text.secondary',
                  textAlign: 'center'
                }}
              >
                No banners available at the moment
              </Typography>
            </Box>
          )}
        </Box>
      </Container>

      {/* Decorative Elements - Smaller and less intrusive */}
      <Box
        sx={{
          position: 'absolute',
          top: '15%',
          right: '3%',
          width: { xs: 40, md: 60 },
          height: { xs: 40, md: 60 },
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(19, 84, 193, 0.08) 0%, rgba(13, 71, 161, 0.04) 100%)',
          filter: 'blur(15px)',
          animation: 'float 6s ease-in-out infinite',
          '@keyframes float': {
            '0%, 100%': {
              transform: 'translateY(0px)',
            },
            '50%': {
              transform: 'translateY(-15px)',
            },
          },
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '15%',
          left: '3%',
          width: { xs: 30, md: 50 },
          height: { xs: 30, md: 50 },
          borderRadius: '50%',
          background: 'linear-gradient(135deg, rgba(13, 71, 161, 0.08) 0%, rgba(19, 84, 193, 0.04) 100%)',
          filter: 'blur(12px)',
          animation: 'float 8s ease-in-out infinite reverse',
        }}
      />
    </Box>
  );
};
